import {
  View,
  Image,
  Text,
  Alert,
  Switch,
  TextInput,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Modal,
  Platform,
} from "react-native";
import React, { useEffect, useState } from "react";
import { SafeAreaView } from "react-native-safe-area-context";
import {
  deleteUserAccount,
  getUser,
  pauseUserAccount,
} from "../../../services/ProfileSettings/ProfileSettingService";
import { RootState, dispatch, useSelector } from "../../../redux/store";
import editProfileStyle from "../styles/editProfileStyle";
import FeedIcons from "../../../assets/Icons/FeedIcons";
import GlobalStyles from "../../../globalStyles/globalStyles";
import settingsStyle from "../styles/settingsStyle";
import PauseAccount from "../../../modal/UserProfileModals/PauseAccount";
import { setLoggedOut } from "../../../redux/auth/authSlice";
import ProfileIcons from "../../../assets/Icons/FeedIcons/ProfileIcons";
import SettingsIcons from "../../../assets/Icons/SettingsIcons";
import AddEmail from "../../../modal/UserProfileModals/AddEmail";
import SelectLeaving from "../../../modal/OnBoardingModal/SelectLeaving";
import ConfirmDelete from "../../../modal/UserProfileModals/ConfirmDelete";
import AsyncStorage from "@react-native-async-storage/async-storage";
import * as Linking from 'expo-linking';

export default function UserProfileSettings({
  navigation,
}: {
  navigation: any;
}) {
  const [isEnabled, setIsEnabled] = useState(false);
  const [isEnabled1, setIsEnabled1] = useState(false);
  const [userData, setData] = useState<any>(null);;
  const [addRecovery, setAddRecovery] = useState(false);

  // const [toggle, setToggle]: [any, React.Dispatch<React.SetStateAction<any>>] = useState();
  const [pauseAccount, setPauseAccount] = useState(false);
  const [continueButton, setContinueButton] = useState(false);
  const [deleteAccount, setDelete] = useState(false);
  const [reason, setReason] = useState("I met someone");

  function setContinue() {
    setContinueButton(!continueButton);
  }

  function setPause() {
    // console.log("fd")
    setPauseAccount(!pauseAccount);
  }
  function setReasonFun(value: string) {
    setReason(value);
  }

  async function pauseAccountUpdate() {
    const userBody = {
      reason: reason,
    };

    const response = await pauseUserAccount(userBody);
    if (response.message == "Profile deactivated successfully!") {
      navigation.navigate("pause-account");
    }
    // console.log(response);
  }
  async function ConfirmDeleteFunction() {
    const userBody = {
      reason: reason,
    };
    await deleteUserAccount(userBody);
    AsyncStorage.clear()
    dispatch(setLoggedOut())
  }
  async function getUserData() {
    const response = await getUser();
    setData(response?.data);
    // console.log(response?.data);
  }
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getUserData();
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []); // T

  const toggleSwitch = () => setIsEnabled((previousState) => !previousState);
  const toggleSwitch1 = () => setIsEnabled1((previousState) => !previousState);
  return (
  <View style={{flex: 1}}>
    <ScrollView
      style={{
        backgroundColor: "white",
        width: "100%",
        paddingTop: Platform.OS === "web" ? 0 : 20,
      }}
      contentContainerStyle={{
        alignItems: "center",
      }}
    >
      {userData != null && (
        <>
          <View style={editProfileStyle.stickTopBar}>
            <View style={editProfileStyle.backBoxMain}>
              <View style={settingsStyle.backBox}>
                <TouchableOpacity onPress={() => navigation.goBack()}>
                  {/* <Image source={Icons.Back} /> */}
                  <FeedIcons.BackIcon />
                </TouchableOpacity>
                <Text style={GlobalStyles.heading3}>Settings</Text>
              </View>
            </View>
          </View>

          <ScrollView
            showsVerticalScrollIndicator={false}
            style={{ backgroundColor: "white", width: "90%", margin: "auto" }}
          >
            <PauseAccount
              isVisible={continueButton}
              toggleModal={setContinue}
              method1={() => {
                setDelete(true);
                setContinue();
              }}
              method2={pauseAccountUpdate}
              
            />
            <ConfirmDelete
              isVisible={deleteAccount}
              toggleModal={() => setDelete(false)}
              method1={() => {
                setDelete(false);
                // setPauseAccount(false);
              }}
              method2={ConfirmDeleteFunction}
            />
            <SelectLeaving
              isDialog={false}
              isVisible={pauseAccount}
              toggleModal={setPause}
              method1={() => {
                setPauseAccount(false);
                setContinueButton(true);
              }}
              method2={setPause}
              method3={setReasonFun}
            />
            <AddEmail
              isDialog={false}
              isVisible={addRecovery}
              toggleModal={() => setAddRecovery(!addRecovery)}
              method2={setAddRecovery}
              onSelectCountry={"f"}
            />

            {/* <View style={[editProfileStyle.uploadBox, { marginTop: 20 }]}>
              <View style={editProfileStyle.lowerMainHead}>
                <Text style={editProfileStyle.lowerMainHeadText}>Profile</Text>
              </View>
              <View style={settingsStyle.lowerMainHead}>
                <View style={settingsStyle.pauseBox}>
                  <Text
                    style={[
                      GlobalStyles.bodyText,
                      {
                        opacity: 1,
                      },
                    ]}
                  >
                    Pause
                  </Text>
                  <Text style={{ fontSize: 15, opacity: 0.4, marginTop: 4 }}>
                    Pausing prevents your profile from being shown to new
                    people. You can still chat with your current matches
                  </Text>
                </View>
                <Switch
                  trackColor={{
                    false: "#767577",
                    true: "rgba(192, 164, 111, 0.24)",
                  }}
                  thumbColor={isEnabled ? "rgba(192, 164, 111, 1)" : "#f4f3f4"}
                  ios_backgroundColor="#3e3e3e"
                  onValueChange={toggleSwitch}
                  value={isEnabled}
                />
              </View>
            </View> */}

            <View style={[editProfileStyle.uploadBox, { marginTop: 20 }]}>
              <View style={editProfileStyle.lowerMainHead}>
                <Text style={editProfileStyle.lowerMainHeadText}>
                  Phone & email
                </Text>
              </View>
              <View style={settingsStyle.lowerMainHead}>
                <View style={settingsStyle.pauseBox}>
                  <Text style={GlobalStyles.bodyText}>{userData?.phoneNumber}</Text>
                  <Text style={{ fontSize: 15, opacity: 0.4, marginTop: 4 }}>
                    Note: You can’t change the phone number associated with your
                    account.
                  </Text>
                </View>
              </View>
              {/* <View style={editProfileStyle.lowerMainHead}>
                <Text style={GlobalStyles.bodyText}>
                  Add email for account recovery{" "}
                </Text>
                <TouchableOpacity onPress={() => setAddRecovery(true)}>
                  <Text
                    style={{
                      color: "rgba(192, 164, 111, 1)",
                      textDecorationLine: "underline",
                    }}
                  >
                    Add
                  </Text>
                </TouchableOpacity>
              </View> */}
            </View>
            {/* <View style={[editProfileStyle.uploadBox, { marginTop: 20 }]}>
              <View style={editProfileStyle.lowerMainHead}>
                <Text style={editProfileStyle.lowerMainHeadText}>
                  Subscription
                </Text>
              </View>
              <View style={settingsStyle.lowerMainHead}>
                <View style={settingsStyle.pauseBox}>
                  <Text style={GlobalStyles.bodyText}>SparkX Subscriber</Text>
                  <Text style={{ fontSize: 15, opacity: 0.4, marginTop: 4 }}>
                    Your subscription ends on March 05, 2024
                  </Text>
                </View>
              </View>
            </View> */}
            <View style={[editProfileStyle.uploadBox, { marginTop: 20 }]}>
              <View style={editProfileStyle.lowerMainHead}>
                <Text style={editProfileStyle.lowerMainHeadText}>
                  Documents
                </Text>
              </View>
              <View style={editProfileStyle.lowerMainHead}>
                <Text style={GlobalStyles.bodyText}>Privacy policy</Text>
              </View>
              <TouchableOpacity  onPress={()=>Linking.openURL('https://spark.love/terms-conditions')} style={[
                  editProfileStyle.lowerMainHead,
                  { borderBottomColor: "white" },
                ]}>
                <Text style={GlobalStyles.bodyText}>Terms of service</Text>
              </TouchableOpacity>
              {/* <View style={editProfileStyle.lowerMainHead}>
                <Text style={GlobalStyles.bodyText}>Refund policy</Text>
              </View> */}
              {/* <View
                style={[
                  editProfileStyle.lowerMainHead,
                  { borderBottomColor: "white" },
                ]}
              >
                <Text style={GlobalStyles.bodyText}>Licenses</Text>
              </View> */}
            </View>
          </ScrollView>
        </>
      )}
    </ScrollView>
    <View style={[{ position: 'absolute', width: '100%' , bottom: 10, paddingHorizontal: 20, gap: 20, marginBottom: 20 }]}>
      <TouchableOpacity
        onPress={() => {
          dispatch(setLoggedOut());
        }}
        style={[settingsStyle.lowerMainHead2, {
          borderWidth: 0.5,
          borderColor: 'grey',
          gap: 10
        }]}
      >
        <SettingsIcons.LogoutIcon />
        <Text style={GlobalStyles.bodyText}>Log out</Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={[settingsStyle.lowerMainHead2,{
          backgroundColor: 'rgba(255, 0, 0, 0.1)',
          gap: 10
        }]}
        onPress={() => {
          setPauseAccount(!pauseAccount);
        }}
      >
        {/* <Image source={Icons.Delete} /> */}
        <SettingsIcons.DeleteIcon />
        <Text
          style={[
            GlobalStyles.bodyText,
            { color: "red", marginLeft: 5 },
          ]}
        >
          Delete or Pause account
        </Text>
      </TouchableOpacity>
    </View>
  </View>
  );
}
